define('views/content/market_usa',['require','backbone','marionette','views/components/store_product/store_products','collections/products_usa','views/components/store_basket/store_basket','text!templates/content/market.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');

    var StoreProductsView = require('views/components/store_product/store_products');
    var ProductsCollection = require('collections/products_usa');
    var StoreBasketView = require('views/components/store_basket/store_basket');


    var temp = require("text!templates/content/market.html");

    return Backbone.Marionette.LayoutView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'market-page',
        titleKey: 'market',

        initialize: function(options) {
            App.context.changePageTitle(App.polyglot.t(this.titleKey));

            if (App.user && App.user.get('reseller')) {
                this.productsCollection = new ProductsCollection([], {
                    parameters: {
                        'is_listed': true
                    }
                });
            } else {
                this.productsCollection = new ProductsCollection([], {
                    parameters: {
                        'is_listed_customer': true
                    }
                });
            }

            // Update collection limit to fetch all products in this page
            this.productsCollection.limit = 100;
        },

        regions: function() {
            return {
                StoreContainer: ".store-container",
                BasketContainer: ".basket-container"
            };
        },

        onRender: function() {
            this.StoreContainer.show(new StoreProductsView({
                collection: this.productsCollection
            }));

            this.BasketContainer.show(new StoreBasketView());
        }

    });
});
